import React from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription, CardFooter } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { Plus, Receipt, Building2, CheckCircle, Eye } from 'lucide-react';
import { statusColors, statusLabels } from './constants';

export default function FaturamentoTab({ 
  faturas, 
  onNovaFatura, 
  onMarcarPago, 
  onVerDetalhes 
}) {
  return (
    <div className="space-y-4">
      <div className="flex justify-between items-center">
        <h3 className="text-lg font-semibold">Faturas</h3>
        <Button onClick={onNovaFatura} data-testid="btn-nova-fatura">
          <Plus className="w-4 h-4 mr-2" />
          Nova Fatura
        </Button>
      </div>
      
      <div className="grid gap-4">
        {faturas.length === 0 ? (
          <Card>
            <CardContent className="py-8 text-center text-slate-500">
              <Receipt className="w-12 h-12 mx-auto mb-3 text-slate-300" />
              <p>Nenhuma fatura encontrada</p>
              <p className="text-sm mt-1">Clique em "Nova Fatura" para criar uma fatura</p>
            </CardContent>
          </Card>
        ) : (
          faturas.map(fatura => (
            <Card key={fatura.id} data-testid={`fatura-${fatura.id}`}>
              <CardHeader className="pb-2">
                <div className="flex items-center justify-between">
                  <div>
                    <CardTitle className="text-lg">{fatura.numero_fatura}</CardTitle>
                    <CardDescription className="flex items-center gap-2">
                      <Building2 className="w-4 h-4" />
                      {fatura.cliente_nome}
                    </CardDescription>
                  </div>
                  <Badge className={statusColors[fatura.status] || 'bg-gray-100'}>
                    {statusLabels[fatura.status] || fatura.status}
                  </Badge>
                </div>
              </CardHeader>
              <CardContent className="pb-2">
                <div className="grid grid-cols-4 gap-4 text-sm">
                  <div>
                    <span className="text-slate-500">Valor Total:</span>
                    <p className="font-semibold text-lg">R$ {fatura.valor_total?.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</p>
                  </div>
                  <div>
                    <span className="text-slate-500">Período:</span>
                    <p>{fatura.periodo_inicio?.split('T')[0]} a {fatura.periodo_fim?.split('T')[0]}</p>
                  </div>
                  <div>
                    <span className="text-slate-500">Emissão:</span>
                    <p>{fatura.data_criacao ? new Date(fatura.data_criacao).toLocaleDateString('pt-BR') : 'N/A'}</p>
                  </div>
                  <div>
                    <span className="text-slate-500">Itens:</span>
                    <p>{fatura.itens?.length || 0} item(ns)</p>
                  </div>
                </div>
              </CardContent>
              <CardFooter className="flex gap-2 pt-2">
                {fatura.status === 'pendente' && (
                  <Button size="sm" className="bg-green-600 hover:bg-green-700" onClick={() => onMarcarPago(fatura.id)}>
                    <CheckCircle className="w-4 h-4 mr-1" />
                    Marcar Pago
                  </Button>
                )}
                <Button size="sm" variant="outline" onClick={() => onVerDetalhes(fatura)} data-testid={`btn-detalhes-fatura-${fatura.id}`}>
                  <Eye className="w-4 h-4 mr-1" />
                  Detalhes
                </Button>
              </CardFooter>
            </Card>
          ))
        )}
      </div>
    </div>
  );
}
